import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-line-chart-line",
    title: "Trading Education",
    desc: "Structured futures trading education for beginners through advanced investors. Online and in-person programs based in Nairobi.",
    path: "/trading-academy",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Advisory Services",
    desc: "Strategic financial advisory tailored to the African Diaspora, helping families and entrepreneurs navigate cross-border investment landscapes.",
    path: "/advisory",
  },
  {
    icon: "ri-building-2-line",
    title: "Family Office Administration",
    desc: "Comprehensive family office support for wealth structuring, governance, and multi-generational asset management.",
    path: "/services",
  },
  {
    icon: "ri-bank-line",
    title: "Private Credit",
    desc: "Access to private credit solutions and structured financing opportunities for qualified investors and entrepreneurs.",
    path: "/services",
  },
  {
    icon: "ri-funds-line",
    title: "Private Equity",
    desc: "Curated private equity relationships and co-investment opportunities across African and diaspora-connected markets.",
    path: "/services",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "Educational Resources",
    desc: "Webinars, workshops, ebooks, and digital content designed to build financial literacy and investor readiness.",
    path: "/insights",
  },
  {
    icon: "ri-user-star-line",
    title: "Workforce Development",
    desc: "Career pathways and professional development programs connecting talent to opportunities in finance and investment.",
    path: "/services",
  },
  {
    icon: "ri-shake-hands-line",
    title: "Strategic Partnerships",
    desc: "Collaborate with Harambee to expand education, advisory access, and diaspora-centered opportunity through aligned, mission-driven partnerships.",
    path: "/partnerships",
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              What We Offer
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F]">
              Our Services
            </h2>
          </div>
          <p className="text-[#6B6B6B] text-base leading-relaxed max-w-md font-['Inter']">
            From foundational trading education to sophisticated family office support, our platform serves investors at every stage of their wealth-building journey.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group bg-[#F8F6F3] rounded-lg p-7 hover:bg-[#1A4D3C] transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-white/15 mb-5 transition-colors">
                <i className={`${svc.icon} text-[#1A4D3C] group-hover:text-[#C9A961] text-xl transition-colors`} />
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-[#2B2D2F] group-hover:text-white mb-3 transition-colors">
                {svc.title}
              </h3>
              <p className="text-[#6B6B6B] group-hover:text-white/70 text-sm leading-relaxed mb-5 transition-colors font-['Inter']">
                {svc.desc}
              </p>
              <Link
                to={svc.path}
                className="inline-flex items-center gap-1.5 text-[#C9A961] text-sm font-medium hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn more <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md border border-[#1A4D3C] text-[#1A4D3C] font-medium text-sm hover:bg-[#1A4D3C] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Services <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
